import { render, staticRenderFns } from "./index404.vue?vue&type=template&id=bc3e3e68&"
import script from "./index404.vue?vue&type=script&lang=js&"
export * from "./index404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports